import Plugin from "@ckeditor/ckeditor5-core/src/plugin";
import ButtonView from "@ckeditor/ckeditor5-ui/src/button/buttonview";
import Command from "@ckeditor/ckeditor5-core/src/command";

// 1. Define the Command to handle state logic
class AudioUploadCommand extends Command {
  refresh() {
    // This method is called automatically by CKEditor's lifecycle
    const IsUploaded = this.editor.config.get("isMultimediaUploaded");

    this.isEnabled = !IsUploaded;
    // this.isEnabled = !this.value;
  }

  // execute(assetId: string) {
  //   const editor = this.editor;
  //   const audioUrl = `${import.meta.env.VITE_STRAPI_ASSET_AUDIO_URL}/${assetId}`;

  //   editor.model.change((writer) => {
  //     // Use a raw HTML fragment or a dedicated audio element if you have a schema defined
  //     const viewFragment = editor.data.processor.toView(
  //       `<audio controls src="${audioUrl}"></audio>`
  //     );
  //     const modelFragment = editor.data.toModel(viewFragment);
  //     editor.model.insertContent(
  //       modelFragment,
  //       editor.model.document.selection
  //     );
  //   });
  // }
}

export default class AudioUploadPlugin extends Plugin {
  uploadFn: any;
  isMultimediaUploaded: boolean;

  constructor(editor: any) {
    super(editor);
    this.uploadFn = editor.config.get("audioUploadFn");
    this.isMultimediaUploaded = editor.config.get("isMultimediaUploaded");
  }

  init() {
    const editor = this.editor;
    editor.commands.add("audioUpload", new AudioUploadCommand(editor));

    editor.ui.componentFactory.add("audioUpload", (locale) => {
      const button = new ButtonView(locale);
      const command = editor.commands.get("audioUpload")!;

      button.set({
        label: "Upload Audio from computer (MP3,OGG,WAV)",
        tooltip: true,
        withText: false,
        icon: `
<svg fill="#000000" width="36px" height="36px" viewBox="0 0 28 28" style="fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2;" version="1.1" xml:space="preserve" xmlns="http://www.w3.org/2000/svg" xmlns:serif="http://www.serif.com/" xmlns:xlink="http://www.w3.org/1999/xlink">

<g id="Icon">

<path d="M11.997,17.993l-0.002,-0c-1.104,-0 -2.001,0.897 -2.001,2.001c-0,1.105 0.897,2.002 2.001,2.002c1.105,0 2.002,-0.897 2.002,-2.002l0,-7.122c0,-0 6.001,-0.75 6.001,-0.75l0.003,3.867c-1.105,0 -2.002,0.897 -2.002,2.002c-0,1.105 0.897,2.002 2.002,2.002c1.104,-0 2.001,-0.897 2.001,-2.002l-0.005,-7.003c-0,-0.286 -0.123,-0.559 -0.338,-0.749c-0.215,-0.189 -0.501,-0.278 -0.786,-0.242l-8,1c-0.5,0.062 -0.876,0.488 -0.876,0.992l0,6.004Z"/>

<path d="M28,17.001l0.009,-9.806c-0,-1.769 -1.435,-3.203 -3.204,-3.203l-17.614,0c-1.77,0 -3.204,1.434 -3.204,3.203l0,17.603c0,1.768 1.434,3.202 3.204,3.202l11.815,0c0.552,0 1,-0.448 1,-1c0,-0.552 -0.448,-1 -1,-1l-11.815,-0c-0.665,-0 -1.204,-0.538 -1.204,-1.202c0,-0 0,-17.603 0,-17.603c0,-0.664 0.539,-1.203 1.204,-1.203c0,0 17.614,0 17.614,0c0.664,0 1.204,0.539 1.204,1.203c-0,-0 -0.009,9.804 -0.009,9.804c-0,0.552 0.447,1.001 0.999,1.001c0.552,0 1.001,-0.447 1.001,-0.999Z"/>

<path d="M24.004,22.007l-1.004,-0c-0.552,-0 -1,0.448 -1,1c-0,0.552 0.448,1 1,1l1.004,-0l-0,0.99c-0,0.552 0.448,1 1,1c0.552,-0 1,-0.448 1,-1l-0,-0.99l0.996,-0c0.552,-0 1,-0.448 1,-1c-0,-0.552 -0.448,-1 -1,-1l-0.996,-0l-0,-1.007c-0,-0.552 -0.448,-1 -1,-1c-0.552,-0 -1,0.448 -1,1l-0,1.007Z"/>

</g>

</svg>
`
      });

      button.bind("isEnabled").to(command);

      button.on("execute", () => {
        this._openFileDialog(editor);
      });

      return button;
    });
  }

  async _openFileDialog(editor: any) {
    const input = document.createElement("input");
    input.type = "file";
    input.accept = "audio/*";

    input.onchange = async () => {
      const file = input.files?.[0];
      if (!file) return;

      if (!file.type.startsWith("audio/")) {
        alert("Only audio files allowed");
        return;
      }
      // const localUrl = URL.createObjectURL(file);

      const assetURL = await editor.config.get("audioUploadFn")(file);
      if (assetURL) {
        // editor.execute("audioUpload", assetId);
        editor.model.change((writer: any) => {
          const viewFragment = editor.data.processor.toView(
            `<audio controls src=${assetURL}></audio>`
          );

          const modelFragment = editor.data.toModel(viewFragment);

          editor.model.insertContent(
            modelFragment,
            editor.model.document.selection
          );
        });
      }
    };
    input.click();
  }
}
